var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mobile message-reply" }, [
    _c(
      "div",
      { staticClass: "message_input" },
      [
        _c("van-field", {
          staticClass: "input_field",
          attrs: {
            rows: "12",
            type: "textarea",
            maxlength: "500",
            placeholder: "请输入你的回复内容",
            "show-word-limit": "",
          },
          model: {
            value: _vm.message,
            callback: function ($$v) {
              _vm.message = $$v
            },
            expression: "message",
          },
        }),
      ],
      1
    ),
    !_vm.isDesign
      ? _c("div", { staticClass: "message_btn", on: { click: _vm.reply } }, [
          _vm._v("回复"),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }